import React from 'react'

const ModalDeleteService = ({ _handleDelete }) => {
    return (
        <div className="modal fade" id="modalDeleteService" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalDeleteService"></h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                    <div className='mt-3'>
                        <h5 className="modal-title" id="modalDeleteService">Êtes vous sur de vouloir supprimer le service ?</h5>
                            <div className='row my-3 mx-3'>
                                <div className='col-6 text-center'>
                                    <div className='btn btn-outline my-3 shadow rounded' data-bs-dismiss="modal" aria-label="Close" onClick={_handleDelete}>supprimer</div>
                                </div>
                                <div className='col-6 text-center'>
                                    <div className='btn btn-outline my-3 shadow rounded' data-bs-dismiss="modal" aria-label="Close">abandonner</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalDeleteService